module.exports = require("mappersmith");


/*****************
 ** WEBPACK FOOTER
 ** external "mappersmith"
 ** module id = 10
 ** module chunks = 0
 **/